(function (window) {
  'use strict';

  const wrapperOpenClass = 'js-select-tooltip--open';

  function handleTrigger(event) {
    event.target.closest('.js-select-tooltip').classList.toggle(wrapperOpenClass);
    handleAriaExpanded(event);
  }

  // Treat the tooltip option click like a select list option element click.
  function handleTooltipOption(event) {
    const tooltipOption = event.target;
    const wrapper = tooltipOption.closest('.js-select-tooltip');
    const select = wrapper.querySelector('.js-select-tooltip-select');
    const button = wrapper.querySelector('.js-select-tooltip-trigger');

    wrapper.classList.remove(wrapperOpenClass);
    button.setAttribute('aria-expanded', false);
    select.value = tooltipOption.getAttribute('data-value');
    triggerNativeEvent(select, 'change');
  }

  // Updates the aria-expanded on the button .filter-controls__button element.
  function handleAriaExpanded(event) {
    if (event.target.closest('.js-select-tooltip').classList.contains(wrapperOpenClass)) {
      event.target.setAttribute('aria-expanded', true);
    } else {
      event.target.setAttribute('aria-expanded', false);
    }
  }

  // Update the tooltip options to stay in sync with the select list options.
  function handleSelect(event) {
    const select = event.target;
    const value = select.value;
    const wrapper = select.closest('.js-select-tooltip');
    const tooltipOptions = wrapper.querySelectorAll('.js-select-tooltip-option');

    for (let i = 0; i < tooltipOptions.length; i++) {
      const option = tooltipOptions[i];

      if (option.getAttribute('data-value') == value) {
        option.setAttribute('aria-pressed', 'true');
      }
      else {
        option.setAttribute('aria-pressed', 'false');
      }
    }

    // Emit component event with relevant data.
    componentEvents.emitEvent('select-tooltip-changed', [{
      select: select,
    }]);
  }

  function init() {
    const wrappers = document.querySelectorAll('.js-select-tooltip');

    for (let i = 0; i < wrappers.length; i++) {
      if (!wrappers[i].classList.contains('js-component-init')) {
        const trigger = wrappers[i].querySelector('.js-select-tooltip-trigger');
        const select = wrappers[i].querySelector('.js-select-tooltip-select');
        const tooltipOptions = wrappers[i].querySelectorAll('.js-select-tooltip-option');

        trigger.addEventListener('click', handleTrigger);

        select.addEventListener('change', handleSelect);

        for (let i = 0; i < tooltipOptions.length; i++) {
          tooltipOptions[i].addEventListener('click', handleTooltipOption);
        }

        wrappers[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
